import React from "react";
import { Modal, IconButton, Typography, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import GradientCard from "../gradients/GradientCard";

const BaseModal = ({ onClose, headline, children, gradient, modalWidth }) => {
  return (
    <Modal open={true} onClose={onClose}>
      <Box sx={{ border: "none !important", outline: "none !important" }}>
        <GradientCard
          selected={gradient}
          sx={{
            maxWidth: modalWidth ? modalWidth : "600px",
            maxHeight: "calc(100vh - 100px)",
            margin: "50px auto 0px",
            border: "none",
            position: "relative",
            outline: "none !important",
            "> .MuiCard-root": {
              maxHeight: "calc(100vh - 100px)",
              overflow: "auto",
              display: "block",
            },
          }}
        >
          <Box sx={{ padding: "10px 25px", width: "100%" }}>
            <IconButton
              sx={{
                position: "absolute",
                top: "10px",
                right: "10px",
              }}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
            {headline && (
              <Typography variant="h2" sx={{ textAlign: "center" }}>
                {headline}
              </Typography>
            )}
            {children}
          </Box>
        </GradientCard>
      </Box>
    </Modal>
  );
};

export default BaseModal;
